import { render, staticRenderFns } from "./NaturalTextBehaviorEditor.vue?vue&type=template&id=f6e83ef4&scoped=true&"
import script from "./NaturalTextBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./NaturalTextBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NaturalTextBehaviorEditor.vue?vue&type=style&index=0&id=f6e83ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e83ef4",
  null
  
)

export default component.exports